module.exports = __webpack_public_path__ + "9cb27475e870ccc0fca7eb09ca64fd3e.svg";